import React from 'react';
import './About.css';

function About() {
  const team = [
    {
      name: 'Brenita Hall',
      role: 'Stylist',
      instagram: '@beautybybrenita',
      instagramUrl: 'https://www.instagram.com/beautybybrenita',
      bio: 'Brenita is a talented stylist with a passion for color and precision cuts. She stays current with the latest techniques and trends to deliver stunning results every time. Whether you want a bold transformation or a subtle refresh, Brenita brings creativity and expertise to every appointment.',
    },
    {
      name: 'Linda D',
      role: '36 Years Experience',
      instagram: null,
      instagramUrl: null,
      bio: 'With over 36 years of experience, Linda specializes in color, highlights, and haircuts for both men and women. She listens to her clients\u2019 needs and delivers exceptional results. Her decades of expertise and dedication to the craft make her a trusted name in the Chesterfield community.',
    },
  ];

  const values = [
    {
      title: 'Quality',
      desc: 'We use premium products and proven techniques to ensure every client leaves looking and feeling their best.',
    },
    {
      title: 'Experience',
      desc: 'With decades of combined expertise, our team brings unmatched skill and knowledge to every service.',
    },
    {
      title: 'Client-Focused',
      desc: 'Your satisfaction is our priority. We listen, collaborate, and deliver results that exceed expectations.',
    },
  ];

  return (
    <main className="about-page">
      {/* Page Header */}
      <section className="about-header">
        <div className="about-header__content">
          <h1 className="about-header__title">About Us</h1>
          <p className="about-header__subtitle">Your hair, our passion</p>
        </div>
      </section>

      {/* Salon Story */}
      <section className="section" style={{ backgroundColor: '#faf8f6' }}>
        <div className="container">
          <h2 className="section-title">Our Story</h2>
          <div className="about-story">
            <p className="about-story__text">
              Epic Hair Salon is home to a talented team of stylists specializing in color,
              cuts, and styling services. Located in Chesterfield, Michigan, we have been
              serving the community with passion and precision for over three decades.
            </p>
            <p className="about-story__text">
              We believe that great hair starts with a great conversation. Our stylists take the time
              to understand your vision, lifestyle, and hair goals to create a look that is uniquely
              yours. From classic cuts to the latest color techniques, we are here to help you look
              and feel your absolute best.
            </p>
          </div>
        </div>
      </section>

      {/* Meet The Team */}
      <section className="section" style={{ backgroundColor: '#f3ede8' }}>
        <div className="container">
          <h2 className="section-title">Meet The Team</h2>
          <div className="about-team">
            {team.map((member, index) => (
              <div className="about-team__card" key={index}>
                <div className="about-team__avatar">
                  <span className="about-team__avatar-letter">{member.name.charAt(0)}</span>
                </div>
                <h3 className="about-team__name">{member.name}</h3>
                <span className="about-team__role">{member.role}</span>
                {member.instagram && (
                  <a
                    href={member.instagramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="about-team__instagram"
                  >
                    {member.instagram}
                  </a>
                )}
                <p className="about-team__bio">{member.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section" style={{ backgroundColor: '#ffffff' }}>
        <div className="container">
          <h2 className="section-title">Our Values</h2>
          <div className="about-values">
            {values.map((value, index) => (
              <div className="about-values__item" key={index}>
                <div className="about-values__accent"></div>
                <h3 className="about-values__title">{value.title}</h3>
                <p className="about-values__desc">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default About;
